import { useMutation } from '@apollo/client'
import gql from 'graphql-tag'

const VALIDATE_TWILIO_SMS = gql`
  mutation ValidateTwilioSMS($accountSid: String!, $authToken: String!) {
    validateTwilioSms(accountSid: $accountSid, authToken: $authToken) {
      payload {
        valid
        message
        details
      }
    }
  }
`

const VALIDATE_TWILIO_WHATSAPP = gql`
  mutation ValidateTwilioWhatsApp($accountSid: String!, $authToken: String!) {
    validateTwilioWhatsapp(accountSid: $accountSid, authToken: $authToken) {
      payload {
        valid
        message
        details
      }
    }
  }
`

const VALIDATE_BOTMAKER_WHATSAPP = gql`
  mutation ValidateBotmakerWhatsApp($apiToken: String!, $defaultChannelId: String!, $apiUrl: String) {
    validateBotmakerWhatsapp(apiToken: $apiToken, defaultChannelId: $defaultChannelId, apiUrl: $apiUrl) {
      payload {
        valid
        message
        details
      }
    }
  }
`

const VALIDATE_META_WHATSAPP = gql`
  mutation ValidateMetaWhatsApp($accessToken: String!, $phoneNumberId: String!) {
    validateMetaWhatsapp(accessToken: $accessToken, phoneNumberId: $phoneNumberId) {
      payload {
        valid
        message
        details
      }
    }
  }
`

const VALIDATE_SMTP = gql`
  mutation ValidateSMTPConfig($host: String!, $port: Int!, $user: String!, $password: String!) {
    validateSmtpConfig(host: $host, port: $port, user: $user, password: $password) {
      payload {
        valid
        message
        details
      }
    }
  }
`

const VALIDATE_HEALTHSHERPA = gql`
  mutation ValidateHealthSherpa($agentEmail: String!, $apiKey: String!) {
    validateHealthsherpa(agentEmail: $agentEmail, apiKey: $apiKey) {
      payload {
        valid
        message
        details
      }
    }
  }
`

export const useChannelValidation = () => {
  const [validateTwilioSms] = useMutation(VALIDATE_TWILIO_SMS)
  const [validateTwilioWhatsapp] = useMutation(VALIDATE_TWILIO_WHATSAPP)
  const [validateBotmakerWhatsapp] = useMutation(VALIDATE_BOTMAKER_WHATSAPP)
  const [validateMetaWhatsapp] = useMutation(VALIDATE_META_WHATSAPP)
  const [validateSmtp] = useMutation(VALIDATE_SMTP)
  const [validateHealthsherpa] = useMutation(VALIDATE_HEALTHSHERPA)

  return {
    validateTwilioSms,
    validateTwilioWhatsapp,
    validateBotmakerWhatsapp,
    validateMetaWhatsapp,
    validateSmtp,
    validateHealthsherpa,
  }
}
